import { render, staticRenderFns } from "./MiPerfilPage.vue?vue&type=template&id=0c3af092&scoped=true&"
import script from "./MiPerfilPage.js?vue&type=script&lang=js&"
export * from "./MiPerfilPage.js?vue&type=script&lang=js&"
import style0 from "./MiPerfilPage.vue?vue&type=style&index=0&id=0c3af092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3af092",
  null
  
)

export default component.exports